import Text from './Text';
import * as React from 'react';
export const Title = (props) => {
    const { children, ...otherProps } = props;
    return (React.createElement(Text, Object.assign({ type: "title" }, otherProps), children));
};
Title.displayName = 'Title';
export default Title;
//# sourceMappingURL=Title.js.map